export const getFirstDaysDiscount = (discountValue, daysValue = 6, isShort = false) => {
  if (!discountValue) {
    return ''
  }
  const postFix = isShort ? '.' : 'ей'
  return `Скидка ${discountValue}% на первые ${daysValue} дн` + postFix
}
